module.exports = __webpack_public_path__ + "img/70a99f6.jpg";